import type { Dispatch, SetStateAction } from 'react';
import { useEffect, useState } from 'react';

import { fg } from '@confluence/feature-gating';
import { expValEquals } from '@confluence/feature-experiments';

import { getIsSticky } from './isStickyUtilities.ts';

type UseIsStickyParams = {
	isEditor?: boolean;
	elementToObserve?: HTMLElement | null;
};

export const useIsSticky = ({
	isEditor,
	elementToObserve,
}: UseIsStickyParams): readonly [boolean, Dispatch<SetStateAction<boolean>>] => {
	// check if table is already sticky
	const initialStickyState = elementToObserve
		? getIsSticky(
				isEditor &&
					expValEquals(
						'platform_editor_table_sticky_header_improvements',
						'cohort',
						'test_with_overflow',
					)
					? elementToObserve
					: elementToObserve.parentElement,
				isEditor,
			)
		: false;

	const [isSticky, setIsSticky] = useState(
		fg('confluence_frontend_remove_duplicate_sidebar_logic') && initialStickyState,
	);

	useEffect(() => {
		if (!fg('confluence_frontend_remove_duplicate_sidebar_logic')) {
			return;
		}

		setIsSticky(initialStickyState);
	}, [initialStickyState]);

	return [isSticky, setIsSticky] as const;
};
